<template>
  <lottie
    :options="animationOptions"
    :class="[
      isMobile ? 'w-[100%] mt-10' : ''
    ]"
    :height="500"
  />
  <h1>
    Página não encontrada
  </h1>
</template>

<script>
import { computed } from 'vue'

export default {
  data () {
    const isMobile = computed(() => window.innerWidth < 768)

    return {
      isMobile,
      animationOptions: {
        animationData: require('@/assets/lotties/404-not found.json'),
        loop: true,
        autoplay: true
      }
    }
  }
}
</script>

<style>

</style>
